module.exports = __webpack_public_path__ + "static/media/type_a.d619026a.png";